const onPaste = (event) => {
  event.preventDefault()

  const text = (event.originalEvent || event).clipboardData.getData(
    "text/plain"
  )

  const selection = window.getSelection()
  if (!selection.rangeCount) return
  selection.deleteFromDocument()
  selection.getRangeAt(0).insertNode(document.createTextNode(text))
}

/**
 * Generate a unique ID with fallback for non-secure contexts
 */
const generateId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`
}

const extractUrls = (text) => {
  if (!text) return []
  const urlRegex = /(https?:\/\/[^\s]+)/g
  return text.match(urlRegex) || []
}

const getDomainName = (url) => {
  try {
    const urlObj = new URL(url)
    const hostname = urlObj.hostname.replace(/^www\./, "")
    const mainDomain = hostname.split(".")[0]
    return mainDomain.charAt(0).toUpperCase() + mainDomain.slice(1)
  } catch (e) {
    return "Link"
  }
}

export { onPaste, generateId, extractUrls, getDomainName }
